import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import Seo from "@/components/Seo";
import { StarAuthShell } from "@/pages/star/StarLayout";

export default function TeacherLogin() {
  const { login, logout, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && (user.role === "teacher" || user.role === "admin")) navigate("/teacher", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      if (u.role !== "teacher" && u.role !== "admin") {
        logout();
        toast.error("This login is for teachers only.");
        return;
      }
      toast.success("Welcome back!");
      navigate("/teacher", { replace: true });
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <StarAuthShell title="Teacher Login" subtitle="Award and manage student stars.">
      <Seo title="Teacher Login" />
      <form onSubmit={submit} className="mt-6 space-y-4" data-testid="teacher-login-form">
        <div>
          <Label className="mb-1.5 block font-semibold text-slate-700">Email</Label>
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="teacher@ptg.com" data-testid="teacher-login-email" required />
        </div>
        <div>
          <Label className="mb-1.5 block font-semibold text-slate-700">Password</Label>
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="teacher-login-password" required />
        </div>
        <Button type="submit" disabled={loading} className="w-full h-11 bg-blue-900 hover:bg-blue-950" data-testid="teacher-login-submit">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Lock className="h-4 w-4 mr-1.5" /> Sign in</>}
        </Button>
      </form>
      <p className="mt-5 text-sm text-slate-500 text-center">
        Are you a student? <Link to="/student/login" className="font-semibold text-blue-900 hover:underline">Student login</Link>
      </p>
    </StarAuthShell>
  );
}
